import {LiveReducer, ReducerFromState} from "../../../@types/reducers";

export const getLiveBooks = (state: ReducerFromState<LiveReducer>): number[] => state.live.books;